import { RSAA } from 'redux-api-middleware';

const FETCH_VG_EVENTS_STATISTICS_REQUEST = 'FETCH_VG_EVENTS_STATISTICS_REQUEST';
const FETCH_VG_EVENTS_STATISTICS_SUCCESS = 'FETCH_VG_EVENTS_STATISTICS_SUCCESS';
const FETCH_VG_EVENTS_STATISTICS_FAILURE = 'FETCH_VG_EVENTS_STATISTICS_FAILURE';

export const fetchVgStatistics = () => ({
  [RSAA]: {
    types: [FETCH_VG_EVENTS_STATISTICS_REQUEST, FETCH_VG_EVENTS_STATISTICS_SUCCESS, FETCH_VG_EVENTS_STATISTICS_FAILURE],
    endpoint: '/event-statistics/virtual-graduation',
    method: 'GET',
  },
});

const FETCH_EVENTS_STATISTICS_REQUEST = 'FETCH_EVENTS_STATISTICS_REQUEST';
const FETCH_EVENTS_STATISTICS_SUCCESS = 'FETCH_EVENTS_STATISTICS_SUCCESS';
const FETCH_EVENTS_STATISTICS_FAILURE = 'FETCH_EVENTS_STATISTICS_FAILURE';

export const fetchStatistics = (eventIds: string[]) => ({
  [RSAA]: {
    types: [FETCH_EVENTS_STATISTICS_REQUEST, FETCH_EVENTS_STATISTICS_SUCCESS, FETCH_EVENTS_STATISTICS_FAILURE],
    endpoint: `/event-statistics`,
    method: 'POST',
    body: { eventIds },
  },
});

export const fetchAllStatistics = () => ({
  [RSAA]: {
    types: [FETCH_EVENTS_STATISTICS_REQUEST, FETCH_EVENTS_STATISTICS_SUCCESS, FETCH_EVENTS_STATISTICS_FAILURE],
    endpoint: `/event-statistics`,
    method: 'GET',
  },
});
